import ReactGA from "react-ga4";

export const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID ||
  process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ||
  "G-W99BGF6M2N";

export const GOOGLE_ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || "";

const isValidGaId = (id) => typeof id === "string" && /^G-[A-Z0-9]+$/i.test(id);
const isValidAdsId = (id) => typeof id === "string" && /^AW-[A-Z0-9]+$/i.test(id);

let initialized = false;

function ensureGtagStub() {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

function logAnalyticsWarning(message, error) {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.warn(`[analytics] ${message}`, error);
  }
}

/**
 * Idempotent GA4 init. Safe if gtag.js is blocked or loads late.
 * Pageviews are sent explicitly via trackPageView (SPA-friendly).
 */
export function initAnalytics() {
  if (typeof window === "undefined" || initialized) return;
  if (!isValidGaId(GA_MEASUREMENT_ID)) return;

  try {
    ensureGtagStub();

    ReactGA.initialize(GA_MEASUREMENT_ID, {
      gtagOptions: {
        send_page_view: false,
        anonymize_ip: true,
      },
    });

    if (isValidAdsId(GOOGLE_ADS_ID)) {
      window.gtag("config", GOOGLE_ADS_ID, { send_page_view: false });
    }

    initialized = true;
  } catch (error) {
    logAnalyticsWarning("init failed", error);
  }
}

/**
 * Send a single SPA page_view. Prefer gtag so hits still queue if the
 * script loads after first paint; fall back to react-ga4.
 */
export function trackPageView(pathname, search = "") {
  if (typeof window === "undefined") return;

  if (!initialized) {
    initAnalytics();
  }
  if (!initialized) return;

  const pagePath = `${pathname || "/"}${search || ""}`;

  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_title: document.title,
        page_location: window.location.href,
        page_path: pagePath,
        send_to: GA_MEASUREMENT_ID,
      });
      return;
    }

    ReactGA.send({
      hitType: "pageview",
      page: pagePath,
      title: document.title,
    });
  } catch (error) {
    logAnalyticsWarning("pageview failed", error);
  }
}

export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined" || !eventName) return;
  if (!initialized) initAnalytics();
  if (!initialized) return;

  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, params);
      return;
    }
    ReactGA.event(eventName, params);
  } catch (error) {
    logAnalyticsWarning("event failed", error);
  }
}
